import { jsxs, jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { SpaceXs } from "@nxt-costco-com/forge-design-tokens";
import { getSkeletonStyle } from "../lib.js";
const CategoryTileSkeleton = ({
  variant,
  imageSx = {}
}) => {
  const {
    direction,
    sxPrimary,
    sxSecondary = {}
  } = getSkeletonStyle(variant);
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      alignItems: "center",
      direction,
      justifyContent: "center",
      spacing: SpaceXs,
      children: [
        /* @__PURE__ */ jsx(Skeleton, { sx: sxPrimary }),
        /* @__PURE__ */ jsx(
          Skeleton,
          {
            sx: {
              ...sxSecondary,
              ...imageSx
            }
          }
        )
      ]
    }
  );
};
export {
  CategoryTileSkeleton
};
